import React from "react";
import Invoices from "../components/Invoices/Invoices";

export default function TransactionPage() {
  return <Invoices />;
}
